// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.explore-container {
  max-width: 1200px;
  padding: 20px;
}

.explore-mode-tabs {
  display: flex;
  gap: 10px;
  padding: 10px 20px 0;
}

.explore-mode-tab {
  appearance: none;
  border: 1px solid var(--border-color);
  background: var(--bg-secondary);
  color: var(--text-secondary);
  font-size: 14px;
  font-weight: 600;
  border-radius: 999px;
  padding: 8px 14px;
  cursor: pointer;
  transition: border-color 0.2s, color 0.2s, background 0.2s;
}

.explore-mode-tab:hover {
  border-color: var(--accent-primary);
  color: var(--text-primary);
}

.explore-mode-tab.active {
  border-color: var(--accent-primary);
  background: var(--accent-primary);
  color: var(--text-primary);
}

/* Header & Search */
.explore-header {
  margin-bottom: 32px;
  text-align: center;
}

.explore-title {
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 20px;
  color: var(--text-primary);
}

.explore-search {
  display: flex;
  gap: 10px;
  max-width: 600px;
  margin: 0 auto;
}

.explore-search-input {
  flex: 1 1;
  padding: 12px 16px;
  font-size: 16px;
  border: 2px solid var(--border-color);
  border-radius: 8px;
  background: var(--bg-secondary);
  color: var(--text-primary);
  transition: border-color 0.2s;
}

.explore-search-input:focus {
  outline: none;
  border-color: var(--accent-primary);
}

.explore-search-btn {
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 600;
  background: var(--accent-primary);
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: opacity 0.2s;
}

.explore-search-btn:hover {
  opacity: 0.9;
}

/* Section Styling */
.explore-section {
  margin-bottom: 32px;
  border: 2px solid var(--border-color);
  border-radius: 12px;
  padding: 20px;
  background: var(--bg-secondary);
  transition: border-color 0.2s;
}

.explore-section:hover {
  border-color: var(--accent-primary);
}

.explore-section.static-section:hover {
  border-color: var(--border-color);
}

.section-header {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  margin-bottom: 0;
}

.section-title-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
}

.section-title {
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0;
  color: var(--text-primary);
}

.expand-btn {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--bg-tertiary);
  border: 2px solid var(--border-color);
  border-radius: 6px;
  font-size: 20px;
  font-weight: bold;
  color: var(--text-primary);
  cursor: pointer;
  transition: all 0.2s;
}

.expand-btn:hover {
  background: var(--accent-primary);
  border-color: var(--accent-primary);
  color: var(--text-primary);
}

.expand-btn.expanded {
  background: var(--accent-primary);
  border-color: var(--accent-primary);
  color: var(--text-primary);
}

.explore-section .section-subtitle {
  font-size: 0.9rem;
  color: var(--text-secondary);
  display: block;
  margin:0;
}

/* Collapse Button at Bottom */
.collapse-btn-bottom {
  width: 100%;
  margin-top: 20px;
  padding: 12px 16px;
  background: var(--bg-primary);
  border: 2px solid var(--border-color);
  border-radius: 8px;
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--text-secondary);
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.collapse-btn-bottom:hover {
  border-color: var(--accent-primary);
  color: var(--accent-primary);
}

/* Posts Grid */
.posts-grid {
  margin-top: 20px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
}

/* Hashtags Grid */
.hashtags-grid {
  margin-top: 20px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 12px;
}

.hashtag-card {
  padding: 16px;
  background: var(--bg-tertiary);
  border: 2px solid var(--border-color);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  text-align: center;
}

.hashtag-card:hover {
  border-color: var(--accent-primary);
  background: var(--bg-hover);
  transform: translateY(-2px);
}

.hashtag-name {
  font-size: 1rem;
  font-weight: 600;
  color: var(--accent-primary);
}

.hashtag-count {
  font-size: 0.85rem;
  color: var(--text-secondary);
}

/* Creators Grid */
.creators-grid {
  margin-top: 20px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 16px;
}

.creator-card {
  padding: 16px;
  background: var(--bg-tertiary);
  border: 2px solid var(--border-color);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  text-align: left;
}

.creator-card:hover {
  border-color: var(--accent-primary);
  background: var(--bg-hover);
  transform: translateY(-2px);
}

.creator-name {
  font-size: 1rem;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 8px;
}

.creator-stats {
  font-size: 0.85rem;
  color: var(--text-secondary);
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

/* Communities Grid */
.communities-grid {
  margin-top: 20px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 16px;
}

.community-card {
  padding: 16px;
  background: var(--bg-tertiary);
  border: 2px solid var(--border-color);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  text-align: left;
}

.community-card:hover {
  border-color: var(--accent-primary);
  background: var(--bg-hover);
  transform: translateY(-2px);
}

.community-name {
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 8px;
  word-break: break-word;
}

.community-stats {
  font-size: 0.85rem;
  color: var(--text-secondary);
}

/* Footer */
.explore-footer {
  text-align: center;
  margin-top: 48px;
}

.explore-footer .refresh-btn {
  padding: 12px 32px;
  font-size: 16px;
  font-weight: 600;
  background: var(--bg-secondary);
  color: var(--text-primary);
  border: 2px solid var(--border-color);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
}

.explore-footer .refresh-btn:hover {
  border-color: var(--accent-primary);
  background: var(--bg-hover);
}

/* Error & Loading States */
.error-box {
  text-align: center;
  padding: 40px 20px;
  background: var(--bg-secondary);
  border: 2px solid var(--border-color);
  border-radius: 8px;
  margin: 20px 0;
}

.error-box p {
  color: var(--text-primary);
  margin-bottom: 16px;
}

.explore-container .retry-btn {
  padding: 10px 24px;
  background: var(--accent-primary);
  color: var(--text-primary);
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
  transition: opacity 0.2s;
}

.explore-container .retry-btn:hover {
  opacity: 0.9;
}

/* Responsive Design */
@media (max-width: 768px) {
  .explore-mode-tabs {
    padding: 10px 16px 0;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .explore-mode-tab {
    white-space: nowrap;
  }

  .explore-container {
    padding: 16px;
  }

  .explore-section {
    padding: 16px;
  }

  .expand-btn {
    width: 28px;
    height: 28px;
    font-size: 18px;
  }

  .explore-title {
    font-size: 1.5rem;
  }

  .explore-search {
    flex-direction: column;
  }

  .posts-grid {
    grid-template-columns: 1fr;
  }

  .hashtags-grid {
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  }

  .creators-grid {
    grid-template-columns: 1fr;
  }

  .communities-grid {
    grid-template-columns: 1fr;
  }

  .section-title {
    font-size: 1.25rem;
  }
}

/* Dark theme specific adjustments */
[data-theme="dark"] .hashtag-card,
[data-theme="dark"] .creator-card,
[data-theme="dark"] .community-card {
  background: var(--bg-tertiary);
}

[data-theme="dimmed"] .hashtag-card,
[data-theme="dimmed"] .creator-card,
[data-theme="dimmed"] .community-card {
  background: var(--bg-tertiary);
}
`, "",{"version":3,"sources":["webpack://./src/pages/Explore.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,+BAA+B;EAC/B,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,eAAe;EACf,qCAAqC;EACrC,kBAAkB;EAClB,+BAA+B;EAC/B,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,cAAc;EACd,QAAQ;AACV;;AAEA,8BAA8B;AAC9B;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,qCAAqC;EACrC,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,0BAA0B;EAC1B,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,0BAA0B;EAC1B,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE;IACE,oBAAoB;IACpB,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,4DAA4D;EAC9D;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,oCAAoC;AACpC;;;EAGE,8BAA8B;AAChC;;AAEA;;;EAGE,8BAA8B;AAChC","sourcesContent":[".explore-container {\r\n  max-width: 1200px;\r\n  padding: 20px;\r\n}\r\n\r\n.explore-mode-tabs {\r\n  display: flex;\r\n  gap: 10px;\r\n  padding: 10px 20px 0;\r\n}\r\n\r\n.explore-mode-tab {\r\n  appearance: none;\r\n  border: 1px solid var(--border-color);\r\n  background: var(--bg-secondary);\r\n  color: var(--text-secondary);\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  border-radius: 999px;\r\n  padding: 8px 14px;\r\n  cursor: pointer;\r\n  transition: border-color 0.2s, color 0.2s, background 0.2s;\r\n}\r\n\r\n.explore-mode-tab:hover {\r\n  border-color: var(--accent-primary);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.explore-mode-tab.active {\r\n  border-color: var(--accent-primary);\r\n  background: var(--accent-primary);\r\n  color: var(--text-primary);\r\n}\r\n\r\n/* Header & Search */\r\n.explore-header {\r\n  margin-bottom: 32px;\r\n  text-align: center;\r\n}\r\n\r\n.explore-title {\r\n  font-size: 2rem;\r\n  font-weight: 700;\r\n  margin-bottom: 20px;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.explore-search {\r\n  display: flex;\r\n  gap: 10px;\r\n  max-width: 600px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.explore-search-input {\r\n  flex: 1;\r\n  padding: 12px 16px;\r\n  font-size: 16px;\r\n  border: 2px solid var(--border-color);\r\n  border-radius: 8px;\r\n  background: var(--bg-secondary);\r\n  color: var(--text-primary);\r\n  transition: border-color 0.2s;\r\n}\r\n\r\n.explore-search-input:focus {\r\n  outline: none;\r\n  border-color: var(--accent-primary);\r\n}\r\n\r\n.explore-search-btn {\r\n  padding: 12px 24px;\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  background: var(--accent-primary);\r\n  color: white;\r\n  border: none;\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  transition: opacity 0.2s;\r\n}\r\n\r\n.explore-search-btn:hover {\r\n  opacity: 0.9;\r\n}\r\n\r\n/* Section Styling */\r\n.explore-section {\r\n  margin-bottom: 32px;\r\n  border: 2px solid var(--border-color);\r\n  border-radius: 12px;\r\n  padding: 20px;\r\n  background: var(--bg-secondary);\r\n  transition: border-color 0.2s;\r\n}\r\n\r\n.explore-section:hover {\r\n  border-color: var(--accent-primary);\r\n}\r\n\r\n.explore-section.static-section:hover {\r\n  border-color: var(--border-color);\r\n}\r\n\r\n.section-header {\r\n  cursor: pointer;\r\n  user-select: none;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.section-title-row {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.section-title {\r\n  font-size: 1.5rem;\r\n  font-weight: 700;\r\n  margin: 0;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.expand-btn {\r\n  width: 32px;\r\n  height: 32px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: var(--bg-tertiary);\r\n  border: 2px solid var(--border-color);\r\n  border-radius: 6px;\r\n  font-size: 20px;\r\n  font-weight: bold;\r\n  color: var(--text-primary);\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.expand-btn:hover {\r\n  background: var(--accent-primary);\r\n  border-color: var(--accent-primary);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.expand-btn.expanded {\r\n  background: var(--accent-primary);\r\n  border-color: var(--accent-primary);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.explore-section .section-subtitle {\r\n  font-size: 0.9rem;\r\n  color: var(--text-secondary);\r\n  display: block;\r\n  margin:0;\r\n}\r\n\r\n/* Collapse Button at Bottom */\r\n.collapse-btn-bottom {\r\n  width: 100%;\r\n  margin-top: 20px;\r\n  padding: 12px 16px;\r\n  background: var(--bg-primary);\r\n  border: 2px solid var(--border-color);\r\n  border-radius: 8px;\r\n  font-size: 0.95rem;\r\n  font-weight: 600;\r\n  color: var(--text-secondary);\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 8px;\r\n}\r\n\r\n.collapse-btn-bottom:hover {\r\n  border-color: var(--accent-primary);\r\n  color: var(--accent-primary);\r\n}\r\n\r\n/* Posts Grid */\r\n.posts-grid {\r\n  margin-top: 20px;\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\r\n  gap: 20px;\r\n}\r\n\r\n/* Hashtags Grid */\r\n.hashtags-grid {\r\n  margin-top: 20px;\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\r\n  gap: 12px;\r\n}\r\n\r\n.hashtag-card {\r\n  padding: 16px;\r\n  background: var(--bg-tertiary);\r\n  border: 2px solid var(--border-color);\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 4px;\r\n  text-align: center;\r\n}\r\n\r\n.hashtag-card:hover {\r\n  border-color: var(--accent-primary);\r\n  background: var(--bg-hover);\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.hashtag-name {\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n  color: var(--accent-primary);\r\n}\r\n\r\n.hashtag-count {\r\n  font-size: 0.85rem;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n/* Creators Grid */\r\n.creators-grid {\r\n  margin-top: 20px;\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\r\n  gap: 16px;\r\n}\r\n\r\n.creator-card {\r\n  padding: 16px;\r\n  background: var(--bg-tertiary);\r\n  border: 2px solid var(--border-color);\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n  text-align: left;\r\n}\r\n\r\n.creator-card:hover {\r\n  border-color: var(--accent-primary);\r\n  background: var(--bg-hover);\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.creator-name {\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.creator-stats {\r\n  font-size: 0.85rem;\r\n  color: var(--text-secondary);\r\n  display: flex;\r\n  gap: 6px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n/* Communities Grid */\r\n.communities-grid {\r\n  margin-top: 20px;\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\r\n  gap: 16px;\r\n}\r\n\r\n.community-card {\r\n  padding: 16px;\r\n  background: var(--bg-tertiary);\r\n  border: 2px solid var(--border-color);\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n  text-align: left;\r\n}\r\n\r\n.community-card:hover {\r\n  border-color: var(--accent-primary);\r\n  background: var(--bg-hover);\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.community-name {\r\n  font-size: 0.95rem;\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n  margin-bottom: 8px;\r\n  word-break: break-word;\r\n}\r\n\r\n.community-stats {\r\n  font-size: 0.85rem;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n/* Footer */\r\n.explore-footer {\r\n  text-align: center;\r\n  margin-top: 48px;\r\n}\r\n\r\n.explore-footer .refresh-btn {\r\n  padding: 12px 32px;\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  background: var(--bg-secondary);\r\n  color: var(--text-primary);\r\n  border: 2px solid var(--border-color);\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.explore-footer .refresh-btn:hover {\r\n  border-color: var(--accent-primary);\r\n  background: var(--bg-hover);\r\n}\r\n\r\n/* Error & Loading States */\r\n.error-box {\r\n  text-align: center;\r\n  padding: 40px 20px;\r\n  background: var(--bg-secondary);\r\n  border: 2px solid var(--border-color);\r\n  border-radius: 8px;\r\n  margin: 20px 0;\r\n}\r\n\r\n.error-box p {\r\n  color: var(--text-primary);\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.explore-container .retry-btn {\r\n  padding: 10px 24px;\r\n  background: var(--accent-primary);\r\n  color: var(--text-primary);\r\n  border: none;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  font-weight: 600;\r\n  transition: opacity 0.2s;\r\n}\r\n\r\n.explore-container .retry-btn:hover {\r\n  opacity: 0.9;\r\n}\r\n\r\n/* Responsive Design */\r\n@media (max-width: 768px) {\r\n  .explore-mode-tabs {\r\n    padding: 10px 16px 0;\r\n    overflow-x: auto;\r\n    -webkit-overflow-scrolling: touch;\r\n  }\r\n\r\n  .explore-mode-tab {\r\n    white-space: nowrap;\r\n  }\r\n\r\n  .explore-container {\r\n    padding: 16px;\r\n  }\r\n\r\n  .explore-section {\r\n    padding: 16px;\r\n  }\r\n\r\n  .expand-btn {\r\n    width: 28px;\r\n    height: 28px;\r\n    font-size: 18px;\r\n  }\r\n\r\n  .explore-title {\r\n    font-size: 1.5rem;\r\n  }\r\n\r\n  .explore-search {\r\n    flex-direction: column;\r\n  }\r\n\r\n  .posts-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .hashtags-grid {\r\n    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));\r\n  }\r\n\r\n  .creators-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .communities-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .section-title {\r\n    font-size: 1.25rem;\r\n  }\r\n}\r\n\r\n/* Dark theme specific adjustments */\r\n[data-theme=\"dark\"] .hashtag-card,\r\n[data-theme=\"dark\"] .creator-card,\r\n[data-theme=\"dark\"] .community-card {\r\n  background: var(--bg-tertiary);\r\n}\r\n\r\n[data-theme=\"dimmed\"] .hashtag-card,\r\n[data-theme=\"dimmed\"] .creator-card,\r\n[data-theme=\"dimmed\"] .community-card {\r\n  background: var(--bg-tertiary);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
